import React from 'react';
import { datasetUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const DataManagementAction = ({ code, disabled }) => (
  <RibbonMenu
    url={`${datasetUrl({ code }, '#')}/data`}
    name="data"
    icon="database"
    message="actions.data.management"
    className="aridhia-dataset-data-management-action"
    disabled={disabled}
  />
);

export default DataManagementAction;
